/**
 * Generate initials from a full name
 * @param fullName - The full name string (e.g., "Rohan Gupta" or "John")
 * @returns Initials string (e.g., "RG" or "J")
 */
export const generateInitials = (fullName: string): string => {
  if (!fullName || fullName.trim() === '') {
    return '';
  }

  const nameParts = fullName.trim().split(/\s+/);
  
  if (nameParts.length === 1) {
    // Only first name, return first letter
    return nameParts[0].charAt(0).toUpperCase();
  } else {
    // Multiple names, return first letter of first and last name
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  }
};

/** Mask email for display to reduce exposure (e.g. ro***@domain.com) */
export const maskEmail = (email: string | null | undefined): string => {
  if (!email || typeof email !== 'string' || !email.includes('@')) return email || '';
  const [local, domain] = email.split('@');
  if (!domain) return email;
  const visible = local.length <= 2 ? local : local.slice(0, 2);
  return `${visible}***@${domain}`;
};
